export const ACTIVE = "Active";

export const INACTIVE = "InActive";

export const PRODUCT_TYPE = Object.freeze({
  OTHERS: "Others",
  LEADERSIMS: "Current and Aspiring School Leader Simulations",
  TEACHERSIMS: "Teacher and Teacher Candidate Simulations",
  INDEPENDENT_SCHOOL_ONLY: "Independent School-Specific Simulations",
  SMALL_DISTRICT: "Small District",
  COUNSELORSIMS: "Counselor and Counselor Candidate Simulations",
  STUDENT_FOCUSED: "Student-Focused Simulations",
});

export const ACCOUNT_TYPE = Object.freeze({
  SCHOOL: "School",
  DISTRICT: "District",
  PARTNER: "Partner",
  HIGHER_ED: "Higher Ed",
});

export const ROLE = Object.freeze({
  Role_Super_Admin: "Role_Super_Admin",
  Role_Admin: "Role_Admin",
});

export const DASHBOARD_PATH = "/dashboard";
export const V2_DASHBOARD_PATH = "/dashboard";

export const getHomeDashboardPath = (role) =>
  role === ROLE.Role_Admin ? V2_DASHBOARD_PATH : DASHBOARD_PATH;

export const ROLE_REPORT_GEN_LIMIT = Object.freeze({
  [ROLE.Role_Super_Admin]: 90,
  [ROLE.Role_Admin]: 120,
  yearly_reporting: 366,
  monthly_reporting: 31,
});

export const Reports = Object.freeze({
  Count_of_Sims_Used: "Count of Sims Used",
  Sims_Played_Count_and_Average_Feedback: "Sims Played Count and Average Feedback",
});

export const Media_Format_and_size_messages = Object.freeze({
  image_size_message:
    "The file size exceeds the limit. The maximum allowed size is 50 MB.",
  image_type_message:
    "Invalid file type. Only image formats (PNG, JPG, JPEG, PJP, PJPEG, JFIF) are allowed.",
  video_size_message:
    "The file size exceeds the limit. The maximum allowed size is 500 MB.",
  video_type_message: "Invalid file type. Only MP4 and WEBM videos are allowed.",
});

export const expiry_date_message = "The expiry date cannot be earlier than the start date."